<template>
  <svg :width="width" :height="height" viewBox="0 0 31 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="warning1111" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="fkaaaaa" transform="translate(-810.000000, -646.000000)" fill="#FAAD14">
        <g id="aaaaaaaafff" transform="translate(680.500000, 611.000000)">
          <g id="Warning" transform="translate(130.000000, 35.000000)">
            <path id="Shape-Copy-2" d="M15,30 C6.71484375,30 0,23.2851562 0,15 C0,6.71484375 6.71484375,0 15,0 C23.2851562,0 30,6.71484375 30,15 C30,23.2851562 23.2851562,30 15,30 L15,30 Z M15.9375,6.5625 C15.9375,6.04394531 15.5185547,5.625 15,5.625 L15,5.625 C14.4814453,5.625 14.0625,6.04394531 14.0625,6.5625 L14.0625,6.5625 C14.0625,7.08105469 14.4814453,7.5 15,7.5 L15,7.5 C15.5185547,7.5 15.9375,7.08105469 15.9375,6.5625 L15.9375,6.5625 L15.9375,6.5625 Z M15.9375,10.3125 C15.9375,9.79394531 15.5185547,9.375 15,9.375 L15,9.375 C14.4814453,9.375 14.0625,9.79394531 14.0625,10.3125 L14.0625,23.4375 C14.0625,23.9560547 14.4814453,24.375 15,24.375 L15,24.375 C15.5185547,24.375 15.9375,23.9560547 15.9375,23.4375 L15.9375,10.3125 L15.9375,10.3125 Z" transform="translate(15.000000, 15.000000) scale(1, -1) translate(-15.000000, -15.000000) " />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">

import { defineComponent } from 'vue'

const Warning = defineComponent({
  props: {
    width: {
      type: String,
      default: '31px'
    },
    height: {
      type: String,
      default: '30px'
    }
  }
})
export default Warning
</script>
